exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row {\n  padding: 10px 5px 10px 20px;\n  margin: 0px 30px; }\n  .row:nth-child(odd) {\n    background: rgba(230, 234, 243, 0.3); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/core/Row/style.scss
// module id = 1041
// module chunks = 0